import http from "../api/http";
import { adoptAccountLang } from "../i18n";
// 路由路径前缀 → 页面 key(跟 Layout.vue 菜单的 key 一致)· 详情页挂到所属页面
const ROUTE_PAGE = [
    ["/overview", "overview"],
    ["/chain-trace", "chain-trace"],
    ["/sales-orders", "sales-orders"],
    ["/retail-orders", "retail-orders"],
    ["/purchase-orders", "purchase-orders"],
    ["/shipments", "shipments"],
    ["/packing-lists", "packing-lists"],
    ["/inventory-hub", "inventory"],
    ["/product-hub", "product-hub"],
    ["/product-master", "product-hub"],
    ["/supplier-hub", "supplier-hub"],
    ["/suppliers", "supplier-hub"],
    ["/customers", "customers"],
    ["/sales-contracts", "customers"],
    ["/forwarder-hub", "forwarder-hub"],
    ["/finance-cash", "fin-cash"],
    ["/finance-expense", "fin-expense"],
    ["/finance-refund", "fin-refund"],
    ["/finance-invoice", "fin-invoice"],
    ["/finance-report", "fin-report"],
    ["/external-platforms", "external-platforms"],
    ["/users", "users"],
    ["/settings", "settings"],
];
// 菜单顺序 · 找「第一个能进的页面」用
const PAGE_HOME = ROUTE_PAGE.filter(([p]) => !["/product-master", "/suppliers"].includes(p));
function storedUser() {
    try {
        return JSON.parse(localStorage.getItem("user") || "{}");
    }
    catch {
        return {};
    }
}
export function isAdmin() {
    const r = storedUser().role;
    return r === "tenant_admin" || r === "platform_admin";
}
export function pageOf(path) {
    for (const [p, key] of ROUTE_PAGE) {
        if (path === p || path.startsWith(p + "/"))
            return key;
    }
    return null;
}
export function levelOf(key) {
    if (isAdmin())
        return "write";
    if (key === "users" || key === "settings")
        return "none"; // 只给管理员
    const perms = storedUser().page_perms;
    if (!perms)
        return "read"; // 老登录信息里没有 → 跟后端默认一致(全部只看)
    return perms[key] || "none";
}
export function canSee(key) {
    return levelOf(key) !== "none";
}
export function firstAllowedPath() {
    for (const [p, key] of PAGE_HOME) {
        if (canSee(key))
            return p;
    }
    return null;
}
/** 从后端刷新本人权限 · 失败不影响使用(后端照样拦) */
export async function refreshPerms() {
    try {
        const r = await http.get("/api/tenant/me/perms");
        const u = storedUser();
        u.page_perms = r.page_perms;
        u.role = r.role;
        if (r.security)
            u.security = r.security; // 2026-09-29 安全加强模式的密码规则
        localStorage.setItem("user", JSON.stringify(u));
        // 账号上的语言跟本机不一样(换了电脑 / 别处改过)→ 切过去
        if (adoptAccountLang(r.language))
            location.reload();
    }
    catch { /* ignore */ }
}
//# sourceMappingURL=pagePerms.js.map